import { Column } from "../objects/column";
import { FunnelBookingEngineRuleForm, FunnelBookingEngineRuleListConfiguration, FunnelBookingEngineRuleListCriteria, FunnelBookingEngineRuleLocalization } from "../objects/funnelBookingEngineRule";

export const FUNNEL_BOOKING_ENGINE_RULE_MODULE = 'CIRCUIT_FUNNEL_BOOKING_ENGINE_RULE';

export const EMPTY_FUNNEL_BOOKING_ENGINE_RULE_LOCALIZATION: FunnelBookingEngineRuleLocalization = {
    name: '',
    locale: 0,
};

export const BOOKING_ENGINE_RULE_DEFAULT_COLUMNS: Column[] = [
    { label: 'name', field_name: 'NAME', checked: true, order_by: 'name', fixed_width: false, last_updated: false, width: null },
    { label: 'destination', field_name: 'DESTINATION', checked: true, order_by: '', fixed_width: false, last_updated: false, width: null },
    { label: 'market', field_name: 'MARKET', checked: true, order_by: '', fixed_width: false, last_updated: false, width: null },
    { label: 'modified-date', field_name: 'MODIFIED_DATE', checked: true, order_by: 'modified_date', fixed_width: true, last_updated: false, width: null },
    { label: 'modified-by', field_name: 'MODIFIED_BY', checked: false, order_by: 'last_author__username', fixed_width: true, last_updated: false, width: null },
    { label: 'created-date', field_name: 'CREATED_DATE', checked: false, order_by: 'created_date', fixed_width: true, last_updated: false, width: null },
    { label: 'created-by', field_name: 'CREATED_BY', checked: false, order_by: 'creator__username', fixed_width: true, last_updated: false, width: null },
];

export const EMPTY_FUNNEL_BOOKING_ENGINE_RULE_LIST_CONFIGURATION: FunnelBookingEngineRuleListConfiguration = {
    columns: BOOKING_ENGINE_RULE_DEFAULT_COLUMNS,
    preferences: [],
};

export const EMPTY_FUNNEL_BOOKING_ENGINE_RULE_FORM: FunnelBookingEngineRuleForm = {
    name: '',
    name_localized: {},
    localization: [],
    apply_to_all_destinations: true,
    destinations: [],
    markets: [],
    booking_engines: [],
};

export const EMPTY_FUNNEL_BOOKING_ENGINE_RULE_LIST_CRITERIA: FunnelBookingEngineRuleListCriteria = {
    limit: 25,
    page: 0,
    search: '',
    order: 'asc',
    order_by: '',
    cms_id: null,
    funnel_id: null,
};
